import { useState } from "react";

export default function CostInHours() {
  const [wage, setWage] = useState(25);
  const [price, setPrice] = useState(160);
  const hourly = Number(wage) || 0;
  const cost = Number(price) || 0;
  const hours = hourly > 0 ? cost / hourly : 0;
  const days = hours / 8;

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>Cost in Hours</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>Translate a purchase into the hours of work it costs based on your hourly wage.</p>

        <div className="card-base" style={{ padding: 18, marginBottom: 18 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Hourly wage</div>
              <input className="input" type="number" value={wage} onChange={(e) => setWage(e.target.value)} placeholder="e.g. 25" />
            </label>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Item price</div>
              <input className="input" type="number" value={price} onChange={(e) => setPrice(e.target.value)} placeholder="e.g. 160" />
            </label>
          </div>
        </div>

        <div className="card-base" style={{ padding: 18 }}>
          {hourly > 0 ? (
            <>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Work cost</div>
              <div style={{ fontFamily: "Fraunces, serif", fontSize: 28 }}>
                {hours.toFixed(1)} hours
              </div>
              <div style={{ color: "var(--t2)", marginTop: 8 }}>
                About {days.toFixed(1)} workdays at 8 hours per day.
              </div>
            </>
          ) : (
            <div style={{ color: "var(--t3)" }}>Enter a positive hourly wage to compute the result.</div>
          )}
        </div>
      </div>
    </main>
  );
}
